/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Nav_Go_Up_HintInputs */



/**
* | output |
* | --- |
* | "Go up one level (Alt + ↑)" |
*
* @param {Spaces_Nav_Go_Up_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_nav_go_up_hint = /** @type {((inputs?: Spaces_Nav_Go_Up_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Nav_Go_Up_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine Ebene nach oben (Alt + ↑)")
	return /** @type {LocalizedString} */ ("Go up one level (Alt + ↑)")
});